import React from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"

export const GenericTitleSection = ({ title, canEditSection, editProfileFunction }) => (
    <div className="section-title-container profile-about-toggle">
        <div className="section-title">{title}</div>
        {canEditSection && (
            <Button className="editButton" onClick={editProfileFunction}>
                Edit
            </Button>
        )}
    </div>
)
GenericTitleSection.propTypes = {
    title: PropTypes.string,
    canEditSection: PropTypes.bool,
    editProfileFunction: PropTypes.func,
}

export const DlcTitleSection = ({ title }) => (
    <div className="section-title-container profile-about-toggle dlc-dtv-section-title">{title}</div>
)

DlcTitleSection.propTypes = {
    title: PropTypes.string,
}
